var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShowerIcon = function SvgShowerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.49998L8.8964 5.17496C6.23148 3.74 3 5.67014 3 8.69685V22M18 7.99998L19 8.99998M21 11L22 12M12 14L13 15M18 14L19 15M15 11L16 12M15 17L16 18M9.53553 12.6066C7.58291 10.654 7.58291 7.48813 9.53553 5.53551C11.4882 3.58289 14.654 3.58289 16.6066 5.53551L9.53553 12.6066Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgShowerIcon;